import { Row, Stack } from 'react-bootstrap';
import { usePatientProfile } from '../hooks';

interface MoreDetailsProps {
  onClickOpenPatientInfo: () => void;
  onClickEditProfile: () => void;
}
const MoreDetails = ({
  onClickEditProfile,
  onClickOpenPatientInfo,
}: MoreDetailsProps) => {
  const { openPatientInfo, editProfile } = usePatientProfile();
  return (
    <>
      {editProfile && (
        <div className="d-flex justify-content-center my-2">
          <Stack direction="horizontal" gap={2} className="mb-2">
            <button
              className="btn btn-long btn-xs btnSecondary ms-auto"
              onClick={onClickEditProfile}
            >
              Cancel
            </button>
            <button className="btn btn-long btn-xs btnPrimary">Save</button>
          </Stack>
        </div>
      )}
      <Row className="position-relative height-0 mt-4">
        <span
          className={
            openPatientInfo
              ? 'expand-button hide-in-pdf'
              : 'close-button hide-in-pdf'
          }
          onClick={onClickOpenPatientInfo}
          aria-controls="more-details"
          aria-expanded={openPatientInfo}
          data-target="#more-details"
          style={{
            cursor: 'pointer',
            position: 'absolute',
            left: '10px',
            width: '68px',
          }}
        >
          {openPatientInfo ? 'Close' : 'Open'}
        </span>
      </Row>
    </>
  );
};

export default MoreDetails;
